import { Skeleton, Stack } from '@mantine/core';

/** Skeleton statt Spinner in Flächen (Brief §7). */
export function PageSkeleton() {
  return (
    <Stack gap="md" data-testid="page-skeleton">
      <Skeleton height={32} width={280} />
      <Skeleton height={16} width={420} />
      <Skeleton height={180} />
      <Skeleton height={320} />
    </Stack>
  );
}
